import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../../../services/PostTemplate";
import { Dropdown } from "primereact/dropdown";
import SecuredFileChange from "../../../../components/SecuredFileChange/SecuredFileChange";
import classNames from "classnames";
import { Dialog } from "primereact";
import { endPoints } from "../../../../Config";

const AddSubPart = ({ onHide, getSubPartList }) => {
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [partlogoLink, setPartlogoLink] = useState("");
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [displayImageDialog, setDisplayImageDialog] = useState(false);

    const categoryTypes = [
        { id: 1, name: "Engine Components" },
        { id: 2, name: "Suspension & Steering" },
        { id: 3, name: "Breaking System" },
        { id: 4, name: "Exhaust System" },
        { id: 5, name: "Body & Exterior" },
        { id: 6, name: "Interior Components" },
        { id: 7, name: "Sensors & Electrical Components" },
        { id: 8, name: "Transmission Components" },
    ];

    const partImageRef = useRef(null);

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            ?.matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .required("This field is required"),
        categoryId: Yup.string().required("This field is required"),
        imageBase64: Yup.string().required("This field is required"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            name: "",
            categoryId: "",
            imageBase64: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);
            let obj = {
                name: data?.name,
                categoryId: data?.categoryId,
                imageBase64: selectedFile ? selectedFile : "",
            };
            const response = await dispatch(handlePostRequest(obj, endPoints.addMasterPart, false, true));
            if (response?.statusCode === 200) {
                getSubPartList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });

    const previewImage = () => {
        setDisplayImageDialog(true);
    };
    const closeDisplayDialog = () => {
        setDisplayImageDialog(false);
    };

    const handleImageReset = () => {
        formik.setFieldValue("imageBase64", "");
        setSelectedFile(null);
        setPartlogoLink("");
        partImageRef.current.value = null; // Reset the file input value
    };
    const handlePartIcon = () => {
        partImageRef.current.click();
    };

    function handlePartImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue("imageBase64", "");
        setSelectedFileError("");
        const selectedFile = event.target.files[0];
        const fileTypes = ["image"];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
            setSelectedFileError(error);
        } else if (newFile) {
            setPartlogoLink(URL.createObjectURL(selectedFile));
            formik.setFieldValue("imageBase64", newFile?.name);
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setSelectedFile(base64String);
            };
            reader.readAsDataURL(newFile);
        }
    }

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Dialog visible={displayImageDialog} blockScroll style={{ width: "40vw" }} maskClassName="zindex9999" onHide={() => closeDisplayDialog()} draggable={false}>
                <img src={selectedFile} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
            </Dialog>
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    {" "}
                    <div className="field col-12 md:col-6">
                        <label> Category </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            placeholder="Select Category"
                            className={classNames({ "p-invalid": isFormFieldValid("categoryId") }, "Dropdown__Round")}
                            id="categoryId"
                            name="categoryId"
                            options={categoryTypes}
                            optionValue="id"
                            optionLabel="name"
                            value={formik.values.categoryId}
                            filter
                            showClear={!!formik?.values?.categoryId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("categoryId", e.target.value ? e.target.value : "");
                            }}
                        />
                        {getFormErrorMessage("categoryId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Part Name </label>
                        <span className="Label__Required">*</span>
                        <InputText placeholder="Enter Part Name" className={classNames({ "p-invalid": isFormFieldValid("name") }, "Input__Round")} id="name" name="name" type="text" maxLength={50} value={formik.values.name} onChange={formik.handleChange} />
                        {getFormErrorMessage("name")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Upload Image </label> <span className="Label__Required">*</span>
                        <div className="file-input-container " onClick={handlePartIcon}>
                            <input type="file" accept="image/*" style={{ display: "none" }} ref={partImageRef} onChange={handlePartImageChange} />
                            <input className={classNames({ "p-invalid": isFormFieldValid("imageBase64") }, "custom-file p-inputtext p-component Input__Round")} type="text" placeholder="Choose a file..." value={formik.values.imageBase64} readOnly />
                            <span className="file-upload-icon">
                                <i className="pi pi-paperclip" />
                            </span>
                        </div>
                        {selectedFileError ? <small className="p-error">{selectedFileError}</small> : getFormErrorMessage("imageBase64")}
                        {formik?.values?.imageBase64 && (
                            <div style={{ position: "relative", width: "180px", height: "180px", margin: "auto", marginTop: "15px" }}>
                                <i className="pi pi-times closingIcon" onClick={() => handleImageReset()} style={{ cursor: "pointer", position: "absolute", top: "0", right: "0" }} />
                                <img
                                    src={partlogoLink}
                                    alt="Part's Logo"
                                    style={{ maxWidth: "100%", maxHeight: "100%", width: "150px", height: "150px", objectFit: "contain" }}
                                    onClick={() => {
                                        previewImage();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        <Button className="Save-Button ml-2" label="Add" type="submit" loading={loadingBtn} />
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddSubPart;
